import { Chip, TextField } from "@mui/material";
import React, { useState } from "react";
import { RiFilter2Fill } from "react-icons/ri";
import {
  ButtonFilter, FilterContainer, IconButtonFilter,
  TypographyFilter, DialogTitleFilter, FormControlFilter, StyledButtonFilter, StyledDivFilter, StyledStack, StackFilter
} from "./style";
import { Dialog, InputLabel, MenuItem, Select } from "@mui/material";
import { EFilterOperation, IFilter } from "../../models/filter";
import ButtonLoading from "../buttonLoading";

interface IField {
  columnName: string;
  valueType: "text" | "boolean" | "select" | "multiselect";
  options?: IFieldOptions[];
}

interface IFieldOptions {
  value: string;
  label: string;
}

interface IProps {
  filters: IFilter[];
  setFilters: React.Dispatch<React.SetStateAction<IFilter[]>>;
  fields: IField[];
}

export default function Filter(props: IProps) {
  const [open, setOpen] = useState(false);
  const [operation, setOperation] = useState<string>(EFilterOperation.EQUAL);
  const [field, setField] = useState(props.fields.at(0)?.columnName);
  const [value, setValue] = useState("");

  function addFilter() {
    const newFilter: IFilter = {
      field: field,
      operation: operation as EFilterOperation,
      value: value,
      key: Date.now()
    };
    props.setFilters((prevFilters) => (prevFilters ? [...prevFilters, newFilter] : [newFilter]));
    setOpen(false);
  }

  function handleDelete(keyToDelete: IFilter) {
    props.setFilters((prevFilters) => prevFilters.filter((filter) => filter.key !== keyToDelete.key));
  }

  function getFieldValue(filter: IFilter) {
    const currentField = props.fields.find((f) => f.columnName === filter.field);
    if (currentField?.valueType === "boolean") {
      if (filter.value === "true") {
        return "Verdadeiro";
      } else {
        return "Falso";
      }
    }
    if (currentField?.valueType === "select") {
      const selectedOption = currentField.options?.find((f) => f.value === filter.value);
      return selectedOption?.label;
    }
    return filter.value;
  }

  return (
    <FilterContainer>
      <ButtonFilter onClick={() => setOpen(true)}>
        <IconButtonFilter type="button" aria-label="search" >
          <RiFilter2Fill color={"#1f299c"} fontSize={16} />
        </IconButtonFilter>
        <TypographyFilter>
          Filtrar
        </TypographyFilter>
      </ButtonFilter>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitleFilter id="alert-dialog-title">
          Adicionar filtro
        </DialogTitleFilter>
        <StyledDivFilter>
          <FormControlFilter variant="standard">
            <InputLabel id="label-id">Coluna</InputLabel>
            <Select
              labelId="label-id"
              value={field}
              onChange={(event) => {
                setField(event.target.value);
                setValue("");
              }}
              label="Operação"
            >
              {props.fields.map(field => (
                <MenuItem value={field.columnName}>{field.columnName}</MenuItem>
              ))}
            </Select>
          </FormControlFilter>
          <FormControlFilter variant="standard">
            <InputLabel id="label-id">Operação</InputLabel>
            <Select
              labelId="label-id"
              value={operation}
              onChange={(event) => setOperation(event.target.value)}
              label="Operação"
            >
              <MenuItem value={EFilterOperation.EQUAL}>Igual</MenuItem>
              <MenuItem value={EFilterOperation.NOT_EQUAL}>Não igual</MenuItem>
            </Select>
          </FormControlFilter>
          <RenderInputValue fields={props.fields} value={value} setValue={setValue} field={field} />
        </StyledDivFilter>
        <StyledButtonFilter>
          <ButtonLoading onClick={() => {
            addFilter();
            setValue("");
          }}>FILTRAR</ButtonLoading>
        </StyledButtonFilter>
      </Dialog>
      <StyledStack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {props.filters.map((filter, index) => (
          <Chip key={index} label={`${filter.field} ${filter.operation} '${getFieldValue(filter)}'`} onDelete={() => handleDelete(filter)} />
        ))}
      </StyledStack>
    </FilterContainer>
  );
}

interface RenderInputValueProps {
  fields: IField[];
  value: string;
  setValue: any;
  field: string | undefined;
}

function RenderInputValue(props: RenderInputValueProps) {
  const selectedField = props.fields.find(f => f.columnName === props.field);

  switch(selectedField?.valueType) {
    case "boolean":
      return (
        <FormControlFilter variant="standard">
          <InputLabel id="label-id">Valor</InputLabel>
          <Select
            labelId="label-id"
            value={props.value}
            onChange={(event) => props.setValue(event.target.value)}
            label="Valor"
          >
            <MenuItem value={"true"}>Verdadeiro</MenuItem>
            <MenuItem value={"false"}>Falso</MenuItem>
          </Select>
        </FormControlFilter>
      );
    case "multiselect":
    case "select":
      return (
        <FormControlFilter variant="standard">
          <InputLabel id="label-id">Valor</InputLabel>
          <Select
            labelId="label-id"
            value={props.value}
            onChange={(event) => props.setValue(event.target.value)}
            label="Valor"
          >
            {
              selectedField.options?.map(opt => <MenuItem value={opt.value}>{opt.label}</MenuItem>)
            }
          </Select>
        </FormControlFilter>
      );
    default:
    case "text":
      return (
        <StackFilter spacing={5}>
          <TextField
            value={props.value}
            onChange={(event) => props.setValue(event.target.value)}
            label="Valor"
            variant="standard"
          />
        </StackFilter>
      );
  }
}
